import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { RestApi } from "src/app/shared/RestApi/restApi";
import { map } from 'rxjs/operators';

interface permissionsDetails {
  message: any;
  error: boolean;
  data: any;
}

interface vaultDNS {
    message: any,
    error: boolean,
    token: string;
    username: string;
    usertype: any,
    details: any,
    users: any,
    photo: any,
    jswPeoples: any,
    residentDetails: any,
    addressDetailDto: any,
    statusMessage: any,
    data: any,
    defaultVaultId:number,
    vaultIds:any,
    dnsName:number,
    vaultDnsname:string
    workspaceId:number
}

@Injectable({
  providedIn: 'root'
})
export class ScreensService {
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi) { }

  retrieveWeb(userId) {

    console.log(userId);

    var screentype = "web"

    console.log(this.restAPI.retrievePermissionNames + "/" + screentype + "/" + userId);

    console.log(screentype);

    console.log(userId);

    this.spinner.start();
    // retervie only screen for which permission given to user
    return this.http.get<permissionsDetails>(this.restAPI.retrievePermissionNames + "/" + screentype + "/" + userId).pipe(
      map(res => {
        //Changed by nikhil 25-11-2019
        //Now it is dynamically connected to database
        console.log(res);
        var parentChildPermissions = [];
        if (res.error == true) {
          this.spinner.stop();
          return false;
        }
        else {
          this.spinner.stop();
          var permissionNames: any = [];
          //Stroing response into permissionNames
          permissionNames = res;
          console.log(permissionNames);

          let firstLevelTemporary = [];

          let firstLevel = [];

          let secondLevel = [];

          permissionNames.forEach(permissionNamesTemporary => {

            if (permissionNamesTemporary.morder > 0) {

              console.log(permissionNamesTemporary.morder);

              firstLevelTemporary.push(permissionNamesTemporary);

            }

            else {

              secondLevel.push(permissionNamesTemporary);

            }

          });

          firstLevelTemporary.forEach(firstLevelTemporaryTemp => {

            firstLevel.push({});

          });

          firstLevelTemporary.forEach(firstLevelTemporaryTemp => {

            firstLevel[firstLevelTemporaryTemp.morder - 1] = firstLevelTemporaryTemp;

          });

          let combineFLSL = firstLevel.concat(secondLevel);

          console.log(combineFLSL);

          permissionNames = combineFLSL;

          var permissionAllAccess;
          //Storing Yes or No into permissionAllAccess
          permissionNames.forEach(permissionNames => {
            if (1001 === permissionNames.screenId && "Yes" === permissionNames.access) {
              permissionAllAccess = permissionNames;
            }
            if (1001 === permissionNames.screenId && "No" === permissionNames.access) {
              permissionAllAccess = permissionNames;
            }
          });

          console.log(permissionAllAccess);

          console.log(permissionAllAccess.access);

          //permissionNames are adding to anotherPermissionNames without 1001 screenId
          var anotherPermissionNames = permissionNames.filter(permissionNames => 1001 !== permissionNames.screenId);
          console.log(anotherPermissionNames);
          var parentChildNames;
          //It will execute when all permissions are not given
          if (permissionAllAccess.access != 'Yes') {
            parentChildNames = anotherPermissionNames.filter(permissionNames => "Yes" === permissionNames.access);
          }
          else {
            parentChildNames = anotherPermissionNames;
          }
          var permissionsLength = parentChildNames.length;
          //Separting child and parent by using level
          var parentNames = parentChildNames.filter(permissionNames => 1 === permissionNames.level);
          var childNames = parentChildNames.filter(permissionNames => 2 === permissionNames.level);
          var childNames1 = parentChildNames.filter(permissionNames => 3 === permissionNames.level);
          var childNames2 = parentChildNames.filter(permissionNames => 4 === permissionNames.level);
          console.log(parentNames);
          console.log(childNames);
          console.log(childNames1);
          console.log(childNames2)
          console.log(parentChildNames);
          //Combining parent and child
          let count = 1;
          let childcount = 1;
          let childcount1 = 1;
          let mergeParentcount;
          parentNames.forEach(parentPermission => {
            var childPermissionNames = [];
            childNames.forEach(childPermission => {
              if (childPermission.parentScreenId === parentPermission.screenId) {
                if (childPermission.urlPath == null) {
                  childNames.forEach(childPermission => {
                    var childPermissionNames1 = [];
                    childNames1.forEach(childPermission1 => {
                      if (childPermission1.parentScreenId === childPermission.screenId) {
                        if (childPermission1.urlPath == null) {
                          childNames1.forEach(childPermission1 => {
                            var childPermissionNames2 = [];
                            childNames2.forEach(childPermission2 => {
                              if (childPermission2.parentScreenId === childPermission1.screenId) {
                                childPermission2["value"] = mergeParentcount + "" + childcount1
                                if (childPermission2.screenType == 'Static') {
                                  childPermission2["urlType"] = childPermission2.urlPath;
                                } else {
                                  childPermission2["urlType"] = 'baseComponent';
                                }
                                childPermission2["checked"] = false;
                                childPermission2["collapsed"] = false;
                                childcount1++;
                                childPermissionNames2.push(childPermission1)
                              }
                            });
                            childPermission1["children"] = childPermissionNames2;
                            console.log(childPermission1["children"])
                          });
                        }
                        if (childPermission1.screenType == 'Static') {
                          childPermission1["urlType"] = childPermission1.urlPath;
                        } else {
                          childPermission1["urlType"] = 'baseComponent';
                        }
                        childPermission1["value"] = mergeParentcount + "" + childcount
                        childPermission1["checked"] = false;
                        childPermission1["collapsed"] = false;
                        childcount++;
                        childPermissionNames1.push(childPermission1)
                      }
                    });
                    childPermission["children"] = childPermissionNames1;
                    console.log(childPermission["children"])
                  });

                }
                if (childPermission.screenType == 'Static') {
                  childPermission["urlType"] = childPermission.urlPath;
                } else {
                  childPermission["urlType"] = 'baseComponent';
                }
                childPermission["value"] = childPermission.parentScreenId + "" + count
                childPermission["checked"] = false;
                childPermission["collapsed"] = false;
                mergeParentcount = childPermission["value"]
                count++;
                childPermissionNames.push(childPermission)

              }
            });
            parentPermission["checked"] = false;
            parentPermission["collapsed"] = false;
            parentPermission["value"] = parentPermission.screenId
            parentPermission["children"] = childPermissionNames;
            console.log(parentPermission);
            console.log(parentPermission);
            parentChildPermissions.push(parentPermission)
          });
          console.log(parentChildPermissions);
        }
        return [permissionsLength, parentChildPermissions];
      }),
    );
  }

  retrieveWebDropDown() {
    console.log(this.restAPI.RETRIEVE_SCREENNAMES_FORDROPDOWN);

    this.spinner.start();
    return this.http.get<permissionsDetails>(this.restAPI.RETRIEVE_SCREENNAMES_FORDROPDOWN).pipe(
      map(res => {
        //Changed by nikhil 25-11-2019
        //Now it is dynamically connected to database
        console.log(res);
        var parentChildPermissions = [];
        if (res.error == true) {
          this.spinner.stop();
          return false;
        }
        else {
          this.spinner.stop();
          var permissionNames: any = [];
          //Stroing response into permissionNames
          permissionNames = res;
          console.log(permissionNames);
          var permissionAllAccess;
          //Storing Yes or No into permissionAllAccess
          // permissionNames.forEach(permissionNames=>
          // {
          // if(1001===permissionNames.screenId && "Yes"===permissionNames.access){
          //permissionAllAccess=permissionNames;
          // }
          //if(1001===permissionNames.screenId && "No"===permissionNames.access){
          //   permissionAllAccess=permissionNames;
          //}
          // });
          //console.log(permissionAllAccess);
          // console.log(permissionAllAccess.access);
          //permissionNames are adding to anotherPermissionNames without 1001 screenId
          //var anotherPermissionNames=permissionNames.filter(permissionNames=>1001!==permissionNames.screenId);
          //console.log(anotherPermissionNames);
          var parentChildNames;
          //It will execute when all permissions are not given
          // if(permissionAllAccess.access!='Yes'){
          //   parentChildNames=anotherPermissionNames.filter(permissionNames=>"Yes"===permissionNames.access);
          // }
          // else{
          parentChildNames = permissionNames;
          // }
          var permissionsLength = parentChildNames.length;
          //Separting child and parent by using level
          var parentNames = parentChildNames.filter(permissionNames => 1 === permissionNames.level);
          var childNames = parentChildNames.filter(permissionNames => 2 === permissionNames.level);
          var childNames1 = parentChildNames.filter(permissionNames => 3 === permissionNames.level);
          var childNames2 = parentChildNames.filter(permissionNames => 4 === permissionNames.level);
          console.log(parentNames);
          console.log(childNames);
          console.log(childNames1);
          console.log(childNames2)
          console.log(parentChildNames);
          //Combining parent and child
          let count = 1;
          let childcount = 1;
          let childcount1 = 1;
          let mergeParentcount;
          parentNames.forEach(parentPermission => {
            var childPermissionNames = [];
            childNames.forEach(childPermission => {
              if (childPermission.parentScreenId === parentPermission.screenId) {
                if (childPermission.urlPath == null) {
                  childNames.forEach(childPermission => {
                    var childPermissionNames1 = [];
                    childNames1.forEach(childPermission1 => {
                      if (childPermission1.parentScreenId === childPermission.screenId) {
                        if (childPermission1.urlPath == null) {
                          childNames1.forEach(childPermission1 => {
                            var childPermissionNames2 = [];
                            childNames2.forEach(childPermission2 => {
                              if (childPermission2.parentScreenId === childPermission1.screenId) {
                                childPermission2["value"] = mergeParentcount + "" + childcount1
                                childPermission2["checked"] = false;
                                childPermission2["collapsed"] = false;
                                childcount1++;
                                childPermissionNames2.push(childPermission1)
                              }
                            });
                            childPermission1["children"] = childPermissionNames2;
                            console.log(childPermission1["children"])
                          });
                        }
                        childPermission1["value"] = mergeParentcount + "" + childcount
                        childPermission1["checked"] = false;
                        childPermission1["collapsed"] = false;
                        childcount++;
                        childPermissionNames1.push(childPermission1)
                      }
                    });
                    childPermission["children"] = childPermissionNames1;
                    console.log(childPermission["children"])
                  });

                }
                childPermission["value"] = childPermission.parentScreenId + "" + count
                childPermission["checked"] = false;
                childPermission["collapsed"] = false;
                mergeParentcount = childPermission["value"]
                count++;
                childPermissionNames.push(childPermission)

              }
            });
            parentPermission["checked"] = false;
            parentPermission["collapsed"] = false;
            parentPermission["value"] = parentPermission.screenId
            parentPermission["children"] = childPermissionNames;
            console.log(parentPermission);
            console.log(parentPermission);
            parentChildPermissions.push(parentPermission)
          });
          console.log(parentChildPermissions);
        }
        return [permissionsLength, parentChildPermissions];
      }),
    );
  }

  retrieveDNSofuser(userid){
    return this.http.get<vaultDNS>(this.restAPI.RETRIEVE_USERDNS_URL+"/"+userid, { headers: this.headers })
  }

  retrieveselectedDNSofuser(vaultdns){
    return this.http.post<vaultDNS>(this.restAPI.RETRIEVE_USERSELECTEDDNS_URL,JSON.stringify(vaultdns), { headers: this.headers })
  }
}